module.exports = __webpack_public_path__ + "static/media/similar_tracks.cd006721.svg";